import { render } from "./Example8.vue?vue&type=template&id=6a785d05"
import script from "./Example8.vue?vue&type=script&lang=ts"
export * from "./Example8.vue?vue&type=script&lang=ts"
script.render = render

export default script